export const TEMPORARY_CLIENT_NAME = "Sin cliente";
export const SALES_HISTORY_QUERY_KEY = ["sales-history"] as const;
export const SALES_SUMMARY_QUERY_KEY = [...SALES_HISTORY_QUERY_KEY, "summary"] as const;
export const SALES_PAGE_SIZE_OPTIONS = [12, 24, 48, 96] as const;
export const DEFAULT_SALES_PAGE_SIZE = SALES_PAGE_SIZE_OPTIONS[0];
export const SALES_IMPORT_HEADERS = [
  'id_transaccion',
  'fecha_venta',
  'id_producto',
  'cantidad',
  'precio_unitario',
  'descuento',
] as const;
